//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SfLink from './SfLink.vue';

export default {
  name: 'SfBreadcrumbs',
  inject: {
    components: {
      default: { SfLink },
    },
  },
  props: {
    breadcrumbs: {
      type: Array,
      default: () => [],
    },
    ariaLabel: {
      type: String,
      default: 'breadcrumb',
    },
  },
  breadcrumbLast(breadcrumbs) {
    return breadcrumbs.length - 1;
  },
};
